/* */ 
(function(process) {
  'use strict';
  var pathParse = require('./path_parse');
  var transformParse = require('./transform_parse');
  var matrix = require('./matrix');
  var a2c = require('./a2c');
  var ellipse = require('./ellipse');
  function SvgPath(path) {
    if (!(this instanceof SvgPath)) {
      return new SvgPath(path);
    }
    var pstate = pathParse(path);
    this.segments = pstate.segments;
    this.err = pstate.err;
    this.__stack = [];
  }
  SvgPath.prototype.__matrix = function(m) {
    var self = this,
        ma,
        sx,
        sy,
        angle,
        arc2line,
        i;
    if (!m.queue.length) {
      return;
    }
    this.iterate(function(s, index, x, y) {
      var p,
          result,
          name,
          isRelative;
      switch (s[0]) {
        case 'v':
          p = m.calc(0, s[1], true);
          result = (p[0] === 0) ? ['v', p[1]] : ['l', p[0], p[1]];
          break;
        case 'V':
          p = m.calc(x, s[1], false);
          result = (p[0] === m.calc(x, y, false)[0]) ? ['V', p[1]] : ['L', p[0], p[1]];
          break;
        case 'h':
          p = m.calc(s[1], 0, true);
          result = (p[1] === 0) ? ['h', p[0]] : ['l', p[0], p[1]];
          break;
        case 'H':
          p = m.calc(s[1], y, false);
          result = (p[1] === m.calc(x, y, false)[1]) ? ['H', p[0]] : ['L', p[0], p[1]];
          break;
        case 'a':
        case 'A':
          var ma = m.toArray();
          var e = ellipse(s[1], s[2], s[3]).transform(ma);
          if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
            s[5] = s[5] ? '0' : '1';
          }
          p = m.calc(s[6], s[7], s[0] === 'a');
          if ((s[0] === 'A' && s[6] === x && s[7] === y) || (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
            result = [s[0] === 'a' ? 'l' : 'L', p[0], p[1]];
            break;
          }
          if (e.isDegenerate()) {
            result = [s[0] === 'a' ? 'l' : 'L', p[0], p[1]];
          } else {
            result = [s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1]];
          }
          break;
        case 'm':
          isRelative = index > 0;
          p = m.calc(s[1], s[2], isRelative);
          result = ['m', p[0], p[1]];
          break;
        default:
          name = s[0];
          result = [name];
          isRelative = (name.toLowerCase() === name);
          for (i = 1; i < s.length; i += 2) {
            p = m.calc(s[i], s[i + 1], isRelative);
            result.push(p[0], p[1]);
          }
      }
      self.segments[index] = result;
    }, true);
  };
  SvgPath.prototype.__evaluateStack = function() {
    var m,
        i;
    if (!this.__stack.length) {
      return;
    }
    if (this.__stack.length === 1) {
      this.__matrix(this.__stack[0]);
      this.__stack = [];
      return;
    }
    m = matrix();
    i = this.__stack.length;
    while (--i >= 0) {
      m.matrix(this.__stack[i].toArray());
    }
    this.__matrix(m);
    this.__stack = [];
  };
  SvgPath.prototype.toString = function() {
    var elements = [],
        skipCmd,
        cmd;
    this.__evaluateStack();
    for (var i = 0; i < this.segments.length; i++) {
      cmd = this.segments[i][0];
      skipCmd = i > 0 && cmd !== 'm' && cmd !== 'M' && cmd === this.segments[i - 1][0];
      elements = elements.concat(skipCmd ? this.segments[i].slice(1) : this.segments[i]);
    }
    return elements.join(' ').replace(/ ?([achlmqrstvz]) ?/gi, '$1').replace(/ \-/g, '-').replace(/zm/g, 'z m');
  };
  SvgPath.prototype.translate = function(x, y) {
    this.__stack.push(matrix().translate(x, y || 0));
    return this;
  };
  SvgPath.prototype.scale = function(sx, sy) {
    this.__stack.push(matrix().scale(sx, (!sy && (sy !== 0)) ? sx : sy));
    return this;
  };
  SvgPath.prototype.rotate = function(angle, rx, ry) {
    this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
    return this;
  };
  SvgPath.prototype.matrix = function(m) {
    this.__stack.push(matrix().matrix(m));
    return this;
  };
  SvgPath.prototype.transform = function(transformString) {
    if (!transformString.trim()) {
      return this;
    }
    this.__stack.push(transformParse(transformString));
    return this;
  };
  SvgPath.prototype.round = function(d) {
    var contourStartDeltaX = 0,
        contourStartDeltaY = 0,
        deltaX = 0,
        deltaY = 0,
        l;
    d = d || 0;
    this.__evaluateStack();
    this.segments.forEach(function(s) {
      var isRelative = (s[0].toLowerCase() === s[0]),
          t;
      switch (s[0]) {
        case 'H':
        case 'h':
          if (isRelative) {
            s[1] += deltaX;
          }
          deltaX = s[1] - s[1].toFixed(d);
          s[1] = +s[1].toFixed(d);
          return;
        case 'V':
        case 'v':
          if (isRelative) {
            s[1] += deltaY;
          }
          deltaY = s[1] - s[1].toFixed(d);
          s[1] = +s[1].toFixed(d);
          return;
        case 'Z':
        case 'z':
          deltaX = contourStartDeltaX;
          deltaY = contourStartDeltaY;
          return;
        case 'M':
        case 'm':
          if (isRelative) {
            s[1] += deltaX;
            s[2] += deltaY;
          }
          deltaX = s[1] - s[1].toFixed(d);
          deltaY = s[2] - s[2].toFixed(d);
          contourStartDeltaX = deltaX;
          contourStartDeltaY = deltaY;
          s[1] = +s[1].toFixed(d);
          s[2] = +s[2].toFixed(d);
          return;
        case 'A':
        case 'a':
          if (isRelative) {
            s[6] += deltaX;
            s[7] += deltaY;
          }
          deltaX = s[6] - s[6].toFixed(d);
          deltaY = s[7] - s[7].toFixed(d);
          s[1] = +s[1].toFixed(d);
          s[2] = +s[2].toFixed(d);
          s[3] = +s[3].toFixed(d + 2);
          s[6] = +s[6].toFixed(d);
          s[7] = +s[7].toFixed(d);
          return;
        default:
          l = s.length;
          if (isRelative) {
            s[l - 2] += deltaX;
            s[l - 1] += deltaY;
          }
          deltaX = s[l - 2] - s[l - 2].toFixed(d);
          deltaY = s[l - 1] - s[l - 1].toFixed(d);
          s.forEach(function(val, i) {
            if (!i) {
              return;
            }
            s[i] = +s[i].toFixed(d);
          });
          return;
      }
    });
    return this;
  };
  SvgPath.prototype.iterate = function(iterator, keepLazyStack) {
    var segments = this.segments,
        replacements = {},
        needReplace = false,
        lastX = 0,
        lastY = 0,
        countourStartX = 0,
        countourStartY = 0;
    var i,
        j,
        isRelative,
        newSegments;
    if (!keepLazyStack) {
      this.__evaluateStack();
    }
    segments.forEach(function(s, index) {
      var res = iterator(s, index, lastX, lastY);
      if (Array.isArray(res)) {
        replacements[index] = res;
        needReplace = true;
      }
      var isRelative = (s[0] === s[0].toLowerCase());
      switch (s[0]) {
        case 'm':
        case 'M':
          lastX = s[1] + (isRelative ? lastX : 0);
          lastY = s[2] + (isRelative ? lastY : 0);
          countourStartX = lastX;
          countourStartY = lastY;
          return;
        case 'h':
        case 'H':
          lastX = s[1] + (isRelative ? lastX : 0);
          return;
        case 'v':
        case 'V':
          lastY = s[1] + (isRelative ? lastY : 0);
          return;
        case 'z':
        case 'Z':
          lastX = countourStartX;
          lastY = countourStartY;
          return;
        default:
          lastX = s[s.length - 2] + (isRelative ? lastX : 0);
          lastY = s[s.length - 1] + (isRelative ? lastY : 0);
      }
    });
    if (!needReplace) {
      return this;
    }
    newSegments = [];
    for (i = 0; i < segments.length; i++) {
      if (typeof replacements[i] !== 'undefined') {
        for (j = 0; j < replacements[i].length; j++) {
          newSegments.push(replacements[i][j]);
        }
      } else {
        newSegments.push(segments[i]);
      }
    }
    this.segments = newSegments;
    return this;
  };
  SvgPath.prototype.abs = function() {
    this.iterate(function(s, index, x, y) {
      var name = s[0],
          nameUC = name.toUpperCase(),
          i;
      if (name === nameUC) {
        return;
      }
      s[0] = nameUC;
      switch (name) {
        case 'v':
          s[1] += y;
          return;
        case 'a':
          s[6] += x;
          s[7] += y;
          return;
        default:
          for (i = 1; i < s.length; i++) {
            s[i] += i % 2 ? x : y;
          }
      }
    }, true);
    return this;
  };
  SvgPath.prototype.rel = function() {
    this.iterate(function(s, index, x, y) {
      var name = s[0],
          nameLC = name.toLowerCase(),
          i;
      if (name === nameLC) {
        return;
      }
      if (index === 0 && name === 'M') {
        return;
      }
      s[0] = nameLC;
      switch (name) {
        case 'V':
          s[1] -= y;
          return;
        case 'A':
          s[6] -= x;
          s[7] -= y;
          return;
        default:
          for (i = 1; i < s.length; i++) {
            s[i] -= i % 2 ? x : y;
          }
      }
    }, true);
    return this;
  };
  SvgPath.prototype.unarc = function() {
    this.iterate(function(s, index, x, y) {
      var i,
          new_segments,
          nextX,
          nextY,
          result = [],
          name = s[0];
      if (name !== 'A' && name !== 'a') {
        return null;
      }
      if (name === 'a') {
        nextX = x + s[6];
        nextY = y + s[7];
      } else {
        nextX = s[6];
        nextY = s[7];
      }
      new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);
      if (new_segments.length === 0) {
        return [[s[0] === 'a' ? 'l' : 'L', s[6], s[7]]];
      }
      new_segments.forEach(function(s) {
        result.push(['C', s[2], s[3], s[4], s[5], s[6], s[7]]);
      });
      return result;
    });
    return this;
  };
  SvgPath.prototype.unshort = function() {
    var segments = this.segments;
    var prevControlX,
        prevControlY,
        prevSegment;
    var curControlX,
        curControlY;
    this.iterate(function(s, idx, x, y) {
      var name = s[0],
          nameUC = name.toUpperCase(),
          isRelative;
      if (!idx) {
        return;
      }
      if (nameUC === 'T') {
        isRelative = (name === 't');
        prevSegment = segments[idx - 1];
        if (prevSegment[0] === 'Q') {
          prevControlX = prevSegment[1] - x;
          prevControlY = prevSegment[2] - y;
        } else if (prevSegment[0] === 'q') {
          prevControlX = prevSegment[1] - prevSegment[3];
          prevControlY = prevSegment[2] - prevSegment[4];
        } else {
          prevControlX = 0;
          prevControlY = 0;
        }
        curControlX = -prevControlX;
        curControlY = -prevControlY;
        if (!isRelative) {
          curControlX += x;
          curControlY += y;
        }
        segments[idx] = [isRelative ? 'q' : 'Q', curControlX, curControlY, s[1], s[2]];
      } else if (nameUC === 'S') {
        isRelative = (name === 's');
        prevSegment = segments[idx - 1];
        if (prevSegment[0] === 'C') {
          prevControlX = prevSegment[3] - x;
          prevControlY = prevSegment[4] - y;
        } else if (prevSegment[0] === 'c') {
          prevControlX = prevSegment[3] - prevSegment[5];
          prevControlY = prevSegment[4] - prevSegment[6];
        } else {
          prevControlX = 0;
          prevControlY = 0;
        }
        curControlX = -prevControlX;
        curControlY = -prevControlY;
        if (!isRelative) {
          curControlX += x;
          curControlY += y;
        }
        segments[idx] = [isRelative ? 'c' : 'C', curControlX, curControlY, s[1], s[2], s[3], s[4]];
      }
    });
    return this;
  };
  module.exports = SvgPath;
})(require('process'));
